
if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    setTimeout(() => {
      const observer = new MutationObserver((MutationList) => {
        for (let item of MutationList) {
          if (item.target.classList?.contains('quick-search__results')) {
            window.dispatchEvent(new Event("scroll"));
          }
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }, 300);
}